import { createAction, props } from '@ngrx/store';
import { RoutePermission } from '../../model/routePermission.model';

/**
 * Actions pour la gestion des permissions de routes
 */

// Load Route Permissions
export const LoadRoutePermissions = createAction(
    '[RoutePermission] Load Route Permissions'
);

export const LoadRoutePermissionsSuccess = createAction(
    '[RoutePermission] Load Route Permissions Success',
    props<{ routePermissions: RoutePermission[] }>()
);

export const LoadRoutePermissionsFailure = createAction(
    '[RoutePermission] Load Route Permissions Failure',
    props<{ error: string }>()
);
